import React, { Component } from "react";
import { ENABLE_RHI } from "../../config/featureFlags";
import _ from "lodash";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/navigation/navigation.scss";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { GlobalState } from "../../types/globalState";
import {
  Button,
  Chip,
  createStyles,
  FormControl,
  MenuItem,
  Paper,
  Select,
  Theme,
  WithStyles,
  TextField,
  Typography,
  IconButton,
  Dialog,
  Switch,
  Grid,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { SportsGolf } from "@material-ui/icons";
import BorderedBox from "../SharedComponents/BorderedBox";
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateUtils from "@date-io/date-fns";
import CompetitionActions from "../../actions/competitions";
import TournamentActions from "../../actions/tournaments";
import CourseActions from "../../actions/courses";
import GameActions from "../../actions/games";
import PaymentAction from "../../actions/payments";
import { switchComponent } from "../../actions/componentRouter";
import LinearProgress from "@material-ui/core/LinearProgress";
import { showSnackbar } from "../SharedComponents/Notifier";
import { Competition, IndexedCompetitions, PlayingFormats } from "../../types/competition";
import { ScoreCard } from "../../types/scoreCard";
import { IndexedTournaments, Tournament } from "../../types/tournament";
import { hideDialog, showDialog } from "../SharedComponents/Dialog";
import { hideAuxiliaryDialog } from "../SharedComponents/AuxiliaryDialog";
import SearchClub from "../Search/SearchClub";
import SearchCourse from "../Search/SearchCourse";
import { Views } from "../Dashboard";
import { Option } from "../SharedComponents/Picker";
import LeaderboardConfig from "../leaderBoard/LeaderboardConfig";
import { TextInput } from "../SharedComponents/TextInput";
import { filter } from "../../utils/profanityFilter";
import { GameAdditionalOrganisersTable } from "./GameAdditionalOrganiserTable";
import { Rules, User, UserBrifObj, License } from "../../types/user";
import { AxiosError } from "axios";
import { Game, Leaderboard, PaymentRules, GameResultRules, HandicapAdjustmentMode, HandicapSourceType } from "../../types/game";
import { defaultPaymentRulesForPaidGame } from "../../utils/paymentCollectionMethod";
import { userIsGameOwner } from "../../utils/gameOrganiser";
import GameNavigationDialog from "./GameNavigationDialog";
import GamePayment from "./GamePayment";
import ScoreCardsList from "./ScoreCardsList";
import GameRuleSelector from "./GameRuleSelector";
import GameHandicapSourceSection from "./GameHandicapSourceSection";
import BestHoles from "components/Competition/BestHoles";
import GameResult from "components/Game/GameResult";
import PresentationInputs, { DEFAULT_PRESENTATION_VALUES } from "components/SharedComponents/PesentationInputs";
import { HELP_VIDEOS } from "consts";
import Config from "config";
import { showAlertDialog } from "components/SharedComponents/AlertDialog";
import { parseOptionalPositiveInt, numberInputProps } from "../../utils/formNumbers";
import RangeHandicapApi from "../../api/rangeHandicap";
import { isRangeGame } from "../../utils/rhiGame";
import { normalizeGameHandicapPayload, showGameSetupHandicapSource, supportsExternalCustomHandicapListing } from "../../utils/gameHandicapSource";
import { resolveAttachedCompetition, resolveCompetitionId } from "../../utils/gameSetupSource";

/** Server-side list cap for game rule picker; keeps custom rules (often sorted after many standards) in range. */
const COMPETITIONS_FETCH_LIMIT_GAME_SETUP = 2000;

interface Props extends WithStyles {
  insertGame(date: any, keepDialog?: boolean, callback?: any): void;
  onboardAccount(redirectUrl: string, callback?: any): void;
  joinGame(code: string, callback?: (error: AxiosError | null, data: Game[]) => void): void;
  updateGame(id: string, data: any, auxiliary?: boolean): void;
  updateGameRule(id: string, ruleId: string): void;
  getScoreCards(courseId: string, callback?: any): void;
  fetchCompetitionsList(
    page: number,
    limit: number,
    filter?: string,
    sort?: string,
    dir?: string,
    query?: string,
  ): void;
  fetchTournamentsList(page: number, limit: number, filter?: any, sort?: string, dir?: string, query?: string): void;
  switchComponent(view: any, props?: any): void;
  loading: boolean;
  competitions: Competition[];
  competitionsObj: IndexedCompetitions;
  tournaments: Tournament[];
  tournamentsObj: IndexedTournaments;
  scoreCards: ScoreCard[];
  edit?: any;
  copy?: any;
  course?: any;
  club?: any;
  user: any;
  onlyGameRule?: boolean;
  onlyPresentationConfig?: boolean;
  auxiliary?: boolean;
}
interface State {
  [index: string]: any;
  game: any;
  scoreCards: ScoreCard[];
  err_name: boolean;
  err_competition: boolean;
  err_scoreCards: boolean;
  err_tournament: boolean;
  err_code: boolean;
  err_msg_code: string;
  dialog: boolean;
  keepPlayers: boolean;
}

class GameSetup extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    let game: any = {
      code: "",
      date: new Date(),
      endTime: new Date(),
      startTime: new Date(),
      club: props.club ? props.club : {},
      course: props.course ? props.course : {},
      scoreCards: [],
      scorers: {},
      competitionId: "",
      tournament: [],
      name: "",
      players: {},
      startingTees: [1],
      leaderboard: { ...DEFAULT_PRESENTATION_VALUES, scoresDisplayOrder: false },
      startSheet: DEFAULT_PRESENTATION_VALUES,
      isPaid: false,
      paymentRules: {},
      verifyQs: false,
      maxPlayers: "",
      isRangeGame: false,
      rangeHandicapMode: undefined as undefined | "automatic",
      handicapSourceType: "game_rule" as HandicapSourceType,
    };
    if (props.edit) {
      game = {
        ...props.edit,
        leaderboard: { ...game.leaderboard, ...props.edit.leaderboard },
      };
      game.startSheet = props.edit.startSheet
        ? { ...game.startSheet, ...props.edit.startSheet }
        : DEFAULT_PRESENTATION_VALUES;
      game.competitionId = resolveCompetitionId(props.edit);
      game.tournament = props.edit.tournaments.map((t: any) => t._id + "," + t.name);
      if (!game.paymentRules) game.paymentRules = {};
      if (game.verifyQs === undefined) game.verifyQs = false;
      game.isRangeGame = !!props.edit.isRangeGame;
      if (game.isRangeGame && !game.rangeHandicapMode) game.rangeHandicapMode = "automatic";
    } else if (props.copy) {
      const competitionId = resolveCompetitionId(props.copy);
      const copyIsRange = !!props.copy.isRangeGame;
      game = {
        ...game,
        ...props.copy,
        competition: competitionId ? { _id: competitionId } : null,
        isRangeGame: copyIsRange,
        rangeHandicapMode: copyIsRange ? props.copy.rangeHandicapMode ?? "automatic" : undefined,
        scorers: {},
      };
      game.competitionId = competitionId;
    }

    const isLimitedGame = GameSetup.isLimitedGameForUser(props.user, game);
    if (game.maxPlayers == null || game.maxPlayers === "") {
      game = { ...game, maxPlayers: isLimitedGame ? 4 : "" };
    }

    this.state = {
      game,
      scoreCards: [],
      err_name: false,
      err_competition: false,
      err_scoreCards: false,
      err_tournament: false,
      err_maxPlayers: false,
      err_code: false,
      err_msg_code: "",
      err_handicap_listing: false,
      err_handicap_adjustment: false,
      dialog: false,
      keepPlayers: false,
      gamePrevName: game?.name,
      canCreateRange: props.user.rule === Rules.Admin,
    };

    props.fetchCompetitionsList(1, COMPETITIONS_FETCH_LIMIT_GAME_SETUP);
    if (!props.copy) {
      props.fetchTournamentsList(1, 50);
      props.getScoreCards(
        game.course._id,
        (err: any, scoreCards: ScoreCard[]) => !err && this.setState({ scoreCards }),
      );
    }
  }

  componentDidMount() {
    this._normalizeHandicapSourceForRule();
    if (this.props.copy && !this.state.game.competitionId) {
      showSnackbar("This game has no game rule to copy (rule may have been deleted).");
    }
    if (this.props.user.rule === Rules.Admin) return;
    RangeHandicapApi.getMyAccess()
      .then(res => this.applyRangeAccess(!!(res.data?.canCreateRangeGames ?? res.data?.canCreateRhiRules)))
      .catch(() => this.applyRangeAccess(false));
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (
      prevState.game.competitionId !== this.state.game.competitionId ||
      prevProps.competitionsObj !== this.props.competitionsObj
    ) {
      this._normalizeHandicapSourceForRule();
    }
  }

  _getSelectedRule = () => {
    const { competitionId } = this.state.game;
    const { competitionsObj, edit, copy } = this.props;
    return competitionsObj[competitionId] || resolveAttachedCompetition(competitionId, edit, copy);
  };

  _validateHandicapSource = () => {
    const currentRule = this._getSelectedRule();
    const showHandicapSource = showGameSetupHandicapSource(currentRule);
    const allowExternalCustomListings = supportsExternalCustomHandicapListing(currentRule);
    const { handicapSourceType, handicapSourceCompetitionId, handicapAdjustmentMode } = this.state.game;
    const err_handicap_listing =
      showHandicapSource &&
      allowExternalCustomListings &&
      handicapSourceType === "custom_rule" &&
      !handicapSourceCompetitionId;
    const err_handicap_adjustment =
      showHandicapSource &&
      allowExternalCustomListings &&
      handicapSourceType === "custom_rule" &&
      !handicapAdjustmentMode;
    return { err_handicap_listing, err_handicap_adjustment, showHandicapSource, allowExternalCustomListings };
  };

  _normalizeHandicapSourceForRule = () => {
    const currentRule = this._getSelectedRule();
    if (supportsExternalCustomHandicapListing(currentRule)) return;
    const { handicapSourceType } = this.state.game;
    if (handicapSourceType !== "custom_rule") return;
    this.updateGameState({
      handicapSourceType: "game_rule",
      handicapSourceCompetitionId: undefined,
      handicapAdjustmentMode: undefined,
    });
  };

  applyRangeAccess = (canCreateRange: boolean) => {
    this.setState(prev => ({
      canCreateRange,
      game: canCreateRange
        ? prev.game
        : { ...prev.game, isRangeGame: false, rangeHandicapMode: undefined },
    }));
  };

  canSelectRangeGame = () => this.props.user.rule === Rules.Admin || this.state.canCreateRange;

  coerceLiveGameIfUnapproved = (game: any) => {
    if (this.canSelectRangeGame()) return game;
    return { ...game, isRangeGame: false, rangeHandicapMode: undefined };
  };

  handleGameTypeChange = (isRange: boolean) => {
    if (isRange && !this.canSelectRangeGame()) return;
    this.updateGameState({
      isRangeGame: isRange,
      rangeHandicapMode: isRange ? "automatic" : undefined,
    });
  };

  handleGameTypeGroupChange = (_: React.MouseEvent<HTMLElement>, value: "live" | "range" | null) => {
    if (value == null) return;
    this.handleGameTypeChange(value === "range");
  };

  gameTypeHelperCopy = () => {
    const isRange = !!this.state.game.isRangeGame;
    if (isRange) {
      return "Uses the Range Handicap Index for handicap strokes when a player has one; otherwise their WHS handicap applies until 3 qualifying range rounds establish the index. The game rule still sets format and scoring. Results update the Range index on close.";
    }
    return "Uses handicaps from the game rule you choose (e.g. WHS HI). Does not use or update the Range Handicap Index.";
  };

  formValidation = () => {
    const { name, scoreCards, competitionId, maxPlayers } = this.state.game;
    const err_name: boolean = name.length < 2 || filter.isProfane(name);
    const err_scoreCards: boolean = Object.values(scoreCards).length === 0;
    const currentRule = this._getSelectedRule();
    const err_competition =
      competitionId.length < 3 || (currentRule && (currentRule as { active?: boolean }).active === false);
    const maxPlayersNum = typeof maxPlayers === "number" ? maxPlayers : parseInt(String(maxPlayers), 10);
    const err_maxPlayers: boolean =
      maxPlayers === "" ||
      !Number.isFinite(maxPlayersNum) ||
      maxPlayersNum < 1 ||
      maxPlayersNum > 1000 ||
      (this.isLimitedGame(this.props.user, this.state.game) && maxPlayersNum > 4);
    const { err_handicap_listing, err_handicap_adjustment } = this._validateHandicapSource();
    this.setState({
      err_name,
      err_scoreCards,
      err_competition,
      err_maxPlayers,
      err_handicap_listing,
      err_handicap_adjustment,
    });
    const rangeBlocked = this.state.game.isRangeGame && !this.canSelectRangeGame();
    if (rangeBlocked) showSnackbar("Only Schala-authorised organisers can create range games.");
    if (err_handicap_adjustment) {
      showSnackbar("Pick how handicaps update after the game.");
    }
    return !(
      err_name ||
      err_scoreCards ||
      err_competition ||
      err_maxPlayers ||
      err_handicap_listing ||
      err_handicap_adjustment ||
      rangeBlocked
    );
  };

  updateGameState = (patch: Record<string, unknown> | ((game: any) => Record<string, unknown>)) => {
    this.setState(prev => ({
      game: {
        ...prev.game,
        ...(typeof patch === "function" ? patch(prev.game) : patch),
      },
    }));
  };

  static isLimitedGameForUser = (user: User, game: any) => {
    if (user.rule === Rules.Player) {
      return true;
    } else if (
      user.rule === Rules.Organiser &&
      user.licenseType === License.ClubLicensed &&
      !(
        game.course?.club?.registered ||
        (user.organisingClub && user.organisingClub.filter(clubId => clubId === game.club?._id).length > 0)
      )
    )
      return true;
    else if (user.rule === Rules.ClubManager && user.club._id !== game.club?._id && !game.club?.registered) {
      return true;
    }
    return false;
  };

  _handleTextFieldChange = (value: string, name: string) => {
    this.updateGameState({ [name]: value });
  };

  _handleMaxPlayersChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const parsed = parseOptionalPositiveInt(event.target.value);
    this.updateGameState({ maxPlayers: parsed });
  };

  _onCompetitionChanges = (selected: Option) => {
    const isMatchplay =
      this.props.competitions.findIndex(
        cmp => cmp._id === selected.id && cmp.playingRules.playingFormat === PlayingFormats.Matchplay,
      ) !== -1;

    this.updateGameState({
      competitionId: selected.id,
      handicapSourceType: "game_rule",
      handicapSourceCompetitionId: undefined,
      handicapAdjustmentMode: undefined,
      gameResultRules: isMatchplay
        ? {
            toResult: true,
            toFinish: false,
            extraHoles: [1],
            toLastHole: false,
            highlightTarget: true,
          }
        : undefined,
    });
  };

  handleHandicapListingChange = (handicapSourceType: HandicapSourceType, handicapSourceCompetitionId?: string) => {
    const prev = this.state.game;
    const nextListingId = handicapSourceType === "custom_rule" ? handicapSourceCompetitionId || "" : "";
    const listingChanged =
      handicapSourceType === "custom_rule" &&
      (prev.handicapSourceType !== "custom_rule" || prev.handicapSourceCompetitionId !== nextListingId);

    this.updateGameState({
      handicapSourceType,
      handicapSourceCompetitionId: nextListingId || undefined,
      handicapAdjustmentMode:
        handicapSourceType !== "custom_rule"
          ? undefined
          : listingChanged
            ? undefined
            : prev.handicapAdjustmentMode,
    });
  };

  handleApplyRulesToggle = (handicapAdjustmentMode: HandicapAdjustmentMode) => {
    this.updateGameState({ handicapAdjustmentMode });
  };

  _onAdditionalOrganisersChage = (organisers: UserBrifObj[]) => {
    this.updateGameState({ organizers: organisers });
  };

  _onTournamentChanges = (event: any) => {
    this.updateGameState({ tournament: event.target.value });
  };
  onTournamentRemoved = (value: string) => {
    this.updateGameState(game => ({
      tournament: game.tournament.filter((x: string) => x != value),
    }));
  };
  _handleDateChange = (date: Date | null) => {
    if (date !== null) {
      this.updateGameState({ date });
    }
  };

  _handleKeepPlayersChange = (keepPlayers: boolean) => {
    this.setState({ keepPlayers });
  };
  _handleStartTimeChange = (date: Date | null) => {
    if (date !== null) {
      this.updateGameState({ startTime: date });
    }
  };
  _handleEndTimeChange = (date: Date | null) => {
    if (date !== null) {
      this.updateGameState({ endTime: date });
    }
  };

  isLimitedGame = (user: User, game: any) => GameSetup.isLimitedGameForUser(user, game);

  handleLeadeboardConfigChanged = (leaderboard: Leaderboard) => {
    this.updateGameState({ leaderboard });
  };

  handleStartSheetConfigChange = (field: string, value: boolean | number) => {
    this.updateGameState(game => ({
      startSheet: { ...game.startSheet, [field]: value },
    }));
  };

  _handleClubSelection = (item: any) => {
    if (item) {
      this.updateGameState({ club: item });
    } else {
      this.updateGameState({ club: {}, course: {} });
    }
  };
  _handleCourseSelection = (item: any) => {
    let course: any = {};
    if (item) {
      course = { ...item };
      this.props.getScoreCards(
        course._id,
        (err: any, scoreCards: ScoreCard[]) => !err && this.setState({ scoreCards }),
      );
      delete course.club;
    }
    this.updateGameState({ course });
  };

  _handleScoreCardPicker = (item: ScoreCard) => {
    this.updateGameState(game => {
      const tmp = [...game.scoreCards];
      return {
        scoreCards: tmp.some((x: any) => x._id === item._id)
          ? tmp.filter((x: any) => x._id != item._id)
          : tmp.concat(item),
      };
    });
  };

  _onPlayersListChanged = (players: any) => {
    this.updateGameState({ players });
  };

  _closeDialog = () => {
    this.setState({ dialog: false });
  };

  _handleHoleClick = (hole: number, holesCount: number) => {
    // All button
    if (hole === -1) {
      const holes = Array.from({ length: holesCount }, (_, i) => i + 1);
      return this.updateGameState({ startingTees: holes });
    }

    this.updateGameState(game => {
      const values = game.startingTees || [];
      return {
        startingTees: values.includes(hole) ? values.filter((x: number) => x !== hole) : values.concat(hole),
      };
    });
  };

  _checkPayBeforeAdd = (confirmCallBack: VoidFunction) => {
    const { game, keepPlayers } = this.state;

    if (keepPlayers && game?.isPaid && game.paymentRules?.payBeforePlay) {
      showAlertDialog(
        "You are adding a players to the pay before play game. You confirm that payment has been made by other means.",
        "",
        confirmCallBack,
        // No
        () => {},
      );
    } else {
      confirmCallBack();
    }
  };

  _submitForm = () => {
    const { tournamentsObj, edit, copy, onlyGameRule } = this.props;

    if (onlyGameRule) {
      this.props.updateGameRule(edit._id, this.state.game.competitionId);
      return;
    }

    if (copy) {
      if (this.state?.gamePrevName?.trim() === this.state.game?.name?.trim()) {
        showSnackbar("Please change game name.");
        return;
      }
      const name = (this.state.game?.name || "").trim();
      if (name.length < 2 || filter.isProfane(name)) {
        this.setState({ err_name: true });
        showSnackbar("Game name is not valid.");
        return;
      }
      const competitionId =
        resolveCompetitionId({ ...this.state.game, competition: this.props.copy?.competition }) ||
        resolveCompetitionId(this.props.copy);
      if (!competitionId || competitionId.length < 3) {
        showSnackbar("This game has no game rule to copy.");
        return;
      }
      const gameForSubmit = this.coerceLiveGameIfUnapproved({
        ...this.state.game,
        competitionId,
      });
      const { showHandicapSource } = this._validateHandicapSource();
      const handicapPayload = showHandicapSource
        ? normalizeGameHandicapPayload(gameForSubmit)
        : { handicapSourceType: "game_rule" as const };
      this._checkPayBeforeAdd(() => {
        this.props.insertGame({
          ...gameForSubmit,
          ...handicapPayload,
          copy: true,
          players: this.state.keepPlayers ? gameForSubmit?.players : {},
        });
      });
      return;
    }

    const { tournament } = this.state.game;
    const _game = {
      ...this.coerceLiveGameIfUnapproved(this.state.game),
      redirectUrl: window.location.href === "/" ? Config.PUBLIC_URL : window.location.href,
    };
    const { showHandicapSource } = this._validateHandicapSource();
    const handicapPayload = showHandicapSource
      ? normalizeGameHandicapPayload(this.state.game)
      : { handicapSourceType: "game_rule" as const };
    let game: any = (({
      name,
      date,
      organizers,
      state,
      leaderboard,
      maxPlayers,
      owner,
      startTime,
      course,
      competition,
      scoreCards,
      isPaid,
      paymentRules,
      startingTees,
      gameResultRules,
      verifyQs,
      startSheet,
      redirectUrl,
      isRangeGame,
      rangeHandicapMode,
    }) => ({
      name,
      date,
      organizers,
      state,
      leaderboard,
      maxPlayers,
      owner,
      startTime,
      course,
      competition,
      scoreCards,
      isPaid,
      paymentRules,
      startingTees,
      gameResultRules,
      verifyQs,
      redirectUrl,
      startSheet,
      isRangeGame: !!isRangeGame,
      rangeHandicapMode: isRangeGame ? rangeHandicapMode || "automatic" : undefined,
      ...handicapPayload,
    }))(_game);

    game.name = game.name.trim();
    game.competition = this.state.game.competition || { _id: this.state.game.competitionId };

    if (this.formValidation()) {
      game.tournaments = tournament.map((t: string) => {
        return tournamentsObj[t.split(",")[0]];
      });
      game.maxPlayers =
        typeof this.state.game.maxPlayers === "number"
          ? this.state.game.maxPlayers
          : parseInt(String(this.state.game.maxPlayers), 10);
      if (game.isPaid) {
        game.paymentRules = defaultPaymentRulesForPaidGame(game.paymentRules);
      }
      // if (game.isPaid) {
      //   showSnackbar("Payment feature is under development");
      // this.props.onboardAccount(game.redirectUrl, (err: any, res: any) => {
      //   if (!err) {
      //     if (res.onboardUrl) {
      //       window.open(res.onboardUrl, "_blank");
      //       showSnackbar("Please complete the payment process to continue");
      //       return;
      //     }
      //     if (edit) {
      //       this.props.updateGame(edit._id, game, this.props.auxiliary);
      //     } else {
      //       this.props.insertGame(game, true, (err: any, res: any) => {
      //         if (!err) {
      //           this.props.switchComponent(Views.DEFAULT);
      //           showDialog(<GameNavigationDialog gameId={res._id} />, "xl", false, true);
      //         }
      //       });
      //     }
      //   }
      // });
      // } else {
      if (edit) {
        this.props.updateGame(
          edit._id,
          { ...game, owner: typeof game.owner === "string" ? game.owner : game.owner._id },
          this.props.auxiliary,
        );
      } else {
        this.props.insertGame(game, true, (err: any, res: any) => {
          if (!err) {
            this.props.switchComponent(Views.DEFAULT);
            showDialog(<GameNavigationDialog gameId={res._id} />, "xl", false, true, true, "Game menu");
          }
        });
      }
      // }
    } else {
      showSnackbar("Form is not valid, check items");
    }
  };

  onPaidSwitchChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isPaid = event.target.checked as boolean;
    this.updateGameState(game => ({
      isPaid,
      paymentRules: isPaid ? defaultPaymentRulesForPaidGame(game.paymentRules) : game.paymentRules,
    }));
  };

  handlePaymentRulesChanged = (paymentRules: PaymentRules) => {
    this.updateGameState({ paymentRules });
  };

  onOpenStripeSetup = () => {
    if (this.props.auxiliary) hideAuxiliaryDialog();
    else hideDialog();
    this.props.switchComponent(Views.Profile);
  };

  handleGameResultRulesChanged = (gameResultRules: GameResultRules) => {
    this.updateGameState({ gameResultRules });
  };

  handleRuleSearchQuery = (q: string) => {
    this.props.fetchCompetitionsList(
      1,
      COMPETITIONS_FETCH_LIMIT_GAME_SETUP,
      undefined,
      "name",
      "asc",
      q || undefined,
    );
  };

  handleRulePickerOpen = () => {
    this.props.fetchCompetitionsList(1, COMPETITIONS_FETCH_LIMIT_GAME_SETUP, undefined, "name", "asc", undefined);
  };

  renderGameTypeSelector() {
    if (!this.canSelectRangeGame()) return null;

    const { classes } = this.props;
    const { game } = this.state;
    const helper = this.gameTypeHelperCopy();

    return (
      <BorderedBox title={"Game type"} variant={"h6"}>
        <ToggleButtonGroup
            exclusive
            size="small"
            value={game.isRangeGame ? "range" : "live"}
            onChange={this.handleGameTypeGroupChange}
            className={classes.gameTypeToggleGroup}
          >
            <ToggleButton value="live" className={classes.gameTypeToggle}>
              Live
            </ToggleButton>
            <ToggleButton value="range" className={classes.gameTypeToggle}>
              Range
            </ToggleButton>
          </ToggleButtonGroup>
        {helper ? (
          <Typography variant="body2" color="textSecondary" component="div" className={classes.gameTypeCaption}>
            {helper}
          </Typography>
        ) : null}
      </BorderedBox>
    );
  }

  renderGameRulesSelector() {
    const { competitions, competitionsObj, edit, copy } = this.props;
    const { competitionId } = this.state.game;
    const attached = resolveAttachedCompetition(competitionId, edit, copy);
    const missingFromStore = attached && !competitionsObj[competitionId];
    const list =
      missingFromStore && !competitions.some(c => c._id === attached!._id)
        ? [...competitions, attached!]
        : competitions;
    const obj =
      missingFromStore && attached
        ? { ...competitionsObj, [attached._id]: attached }
        : competitionsObj;

    return (
      <GameRuleSelector
        competitionId={competitionId}
        competitions={list}
        competitionsObj={obj}
        onChange={this._onCompetitionChanges}
        onSearchQueryChange={this.handleRuleSearchQuery}
        onPickerOpen={this.handleRulePickerOpen}
      />
    );
  }

  renderHandicapSourceSection() {
    const { competitions, competitionsObj, edit, copy } = this.props;
    const { game, err_handicap_listing, err_handicap_adjustment } = this.state;
    const { competitionId, handicapSourceType, handicapSourceCompetitionId, handicapAdjustmentMode } = game;
    const currentRule = this._getSelectedRule();
    const showHandicapSource = showGameSetupHandicapSource(currentRule);
    const allowExternalCustomListings = supportsExternalCustomHandicapListing(currentRule);
    const attached = resolveAttachedCompetition(competitionId, edit, copy);
    const missingFromStore = attached && !competitionsObj[competitionId];
    const handicapCompetitions =
      missingFromStore && !competitions.some(c => c._id === attached!._id)
        ? [...competitions, attached!]
        : competitions;

    if (!showHandicapSource || !competitionId) return null;

    return (
      <GameHandicapSourceSection
        handicapSourceType={handicapSourceType}
        handicapSourceCompetitionId={handicapSourceCompetitionId}
        handicapAdjustmentMode={handicapAdjustmentMode}
        competitions={handicapCompetitions}
        ruleId={competitionId}
        allowExternalCustomListings={allowExternalCustomListings}
        onHandicapListingChange={this.handleHandicapListingChange}
        onApplyRulesToggle={this.handleApplyRulesToggle}
        errListing={err_handicap_listing}
        errAdjustment={err_handicap_adjustment}
      />
    );
  }
  renderTournamentSelector() {
    const { tournaments, classes } = this.props;
    const { tournament } = this.state.game;
    const { err_tournament } = this.state;
    if (tournaments.length > 0) {
      return (
        <FormControl fullWidth margin={"dense"} error={err_tournament}>
          <div className={classes.inline}>
            {tournament.map((value: any) => {
              return (
                <Chip
                  className={classes.selectedTournament}
                  key={value.split(",")[0]}
                  label={value.split(",")[1]}
                  onDelete={() => this.onTournamentRemoved(value)}
                />
              );
            })}
          </div>
          <Select multiple value={tournament} onChange={this._onTournamentChanges}>
            {tournaments.map((item: Tournament) => (
              <MenuItem key={item._id} value={item._id + "," + item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    } else {
      return <p>No Tournament available</p>;
    }
  }
  renderActionButton() {
    const { classes, loading, auxiliary } = this.props;
    if (loading)
      return (
        <div className={classes.loadingContainer}>
          <LinearProgress color="primary" variant={"indeterminate"} />
        </div>
      );
    else
      return (
        <div className={classes.actionButtonContainer}>
          <Button
            fullWidth
            className={classes.actionButton}
            variant={"contained"}
            color={"primary"}
            onClick={this._submitForm}
          >
            Save
          </Button>
          <Button
            fullWidth
            className={classes.actionButton}
            variant={"contained"}
            color={"secondary"}
            onClick={auxiliary ? hideAuxiliaryDialog : hideDialog}
          >
            Cancel
          </Button>
        </div>
      );
  }
  renderCopyFormFields() {
    const { classes } = this.props;
    const { game, err_name, keepPlayers } = this.state;
    const { name, date } = game;

    return (
      <>
        <Typography variant={"h5"} className={classes.title}>
          Copy Game
        </Typography>
        <BorderedBox title={"Game name"} variant={"h6"}>
          <TextInput
            fullWidth
            placeholder={"Enter a name for this game"}
            style={{ margin: 0 }}
            error={err_name}
            captalize
            name={"name"}
            onChange={this._handleTextFieldChange}
            value={name}
          />
        </BorderedBox>
        <BorderedBox title={"Date & 1st Tee Time"} variant={"h6"}>
          <div className={classes.inline}>
            <MuiPickersUtilsProvider utils={DateUtils}>
              <KeyboardDateTimePicker
                id="date"
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                style={{ margin: 0 }}
                value={date}
                onChange={this._handleDateChange}
                className={classes.datePicker}
              />
            </MuiPickersUtilsProvider>
          </div>
        </BorderedBox>
        <FormControlLabel
          className="policy-label"
          control={
            <Checkbox
              checked={keepPlayers}
              onChange={evt => this._handleKeepPlayersChange(evt.target.checked)}
              name="policy"
              color="secondary"
            />
          }
          label={"Should we keep players?"}
        />
        {this.renderActionButton()}
      </>
    );
  }

  renderFormContent() {
    const { classes, auxiliary } = this.props;
    const { game, err_name, err_scoreCards, err_maxPlayers, scoreCards } = this.state;
    const { name, date, organizers, maxPlayers } = game;
    const isLimitedGame = this.isLimitedGame(this.props.user, this.state.game);
    const isPlayer = this.props.user.rule === Rules.Player;
    const holesCount = game.course?.holesNumber || 18;

    if (game.course && game.course._id)
      return (
        <>
          <BorderedBox
            title={"Recent Scorecard"}
            videoIcon
            videoURL={HELP_VIDEOS.GAME_SETUP_SCORE_CARD}
            padding="none"
            variant={"h6"}
            error={err_scoreCards}
          >
            <ScoreCardsList
              cards={scoreCards}
              gameCards={game.scoreCards}
              onScoreCardSelected={this._handleScoreCardPicker}
            />
          </BorderedBox>
          <BorderedBox title={"Game name"} variant={"h6"}>
            <TextInput
              fullWidth
              placeholder={"Enter a name for this game"}
              style={{ margin: 0 }}
              error={err_name}
              captalize
              name={"name"}
              onChange={this._handleTextFieldChange}
              value={name}
            />
          </BorderedBox>
          {ENABLE_RHI ? this.renderGameTypeSelector() : null}
          <BorderedBox title={"Maximum Players"} variant={"h6"}>
            <TextField
              fullWidth
              type="number"
              style={{ margin: 0 }}
              error={err_maxPlayers}
              name={"maxPlayers"}
              inputProps={{ min: 1, max: isLimitedGame ? 4 : 1000, ...numberInputProps }}
              onChange={this._handleMaxPlayersChange}
              value={maxPlayers === "" || maxPlayers == null ? "" : maxPlayers}
            />
          </BorderedBox>
          <BorderedBox title={"Date & 1st Tee Time"} variant={"h6"}>
            <div className={classes.inline}>
              <MuiPickersUtilsProvider utils={DateUtils}>
                <KeyboardDateTimePicker
                  id="date"
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  style={{ margin: 0 }}
                  value={date}
                  onChange={this._handleDateChange}
                  className={classes.datePicker}
                />
              </MuiPickersUtilsProvider>
            </div>
          </BorderedBox>

          <BorderedBox title={"QS Verification"} videoIcon videoURL={HELP_VIDEOS.GAME_SETUP_QS} variant={"h6"}>
            <Grid item md={10} xs={10}>
              <Typography variant="body1" gutterBottom>
                Quick Score verification
              </Typography>
            </Grid>
            <Grid item md={2} xs={2}>
              <Switch
                name="verifyQs"
                value={game.verifyQs}
                checked={game.verifyQs}
                onChange={e => {
                  this.updateGameState({ verifyQs: e.target.checked });
                }}
              />
            </Grid>
          </BorderedBox>

          <BorderedBox title={"Starting Tees"} variant={"h6"}>
            <div>
              <IconButton
                className={classes.teesBtn}
                onClick={() => {
                  this.setState({ dialog: true });
                }}
              >
                <SportsGolf />
              </IconButton>
            </div>

            <div className={classes.holesList}>
              {game.startingTees?.map((x: number) => (
                <Chip key={x} className={classes.hole} style={{ background: "#009e0f", color: "white" }} label={x} />
              ))}
            </div>
          </BorderedBox>

          <BorderedBox title={"Game rules"} variant={"h6"} error={this.state.err_competition}>
            {this.renderGameRulesSelector()}
          </BorderedBox>
          {this.renderHandicapSourceSection()}

          {game.gameResultRules && (
            <BorderedBox title={"Game Result"} variant={"h6"}>
              <GameResult
                holesCount={holesCount}
                gameResultRules={game.gameResultRules}
                onGameResultRulesChanged={this.handleGameResultRulesChanged}
              />
            </BorderedBox>
          )}

          <BorderedBox title={"Leaderboard"} videoIcon videoURL={HELP_VIDEOS.GAME_SETUP_LD} variant={"h6"}>
            <LeaderboardConfig
              leaderboardConfig={game.leaderboard}
              gameId={game._id}
              onLeaderboardConfigChanged={this.handleLeadeboardConfigChanged}
            />
          </BorderedBox>

          <BorderedBox title={"Start Sheet"} variant={"h6"}>
            <PresentationInputs
              fields={game.startSheet}
              handleInputChange={this.handleStartSheetConfigChange}
              onSwitchChange={this.handleStartSheetConfigChange}
            />
          </BorderedBox>

          <BorderedBox title={"Tournament"} videoIcon videoURL={HELP_VIDEOS.GAME_SETUP_TM} variant={"h6"}>
            {this.renderTournamentSelector()}
          </BorderedBox>
          {!isPlayer && (
            <BorderedBox
              title={"Payment"}
              videoIcon
              videoURL={HELP_VIDEOS.GAME_SETUP_PAYMENT}
              variant={"h6"}
              padding="none"
            >
              <GamePayment
                disabled={this.props.edit?.isPaid}
                isPaid={game.isPaid}
                isRangeGame={isRangeGame(game)}
                paymentRules={game.paymentRules}
                gameId={this.props.edit?._id}
                isGameOwner={!this.props.edit || userIsGameOwner(this.props.edit, this.props.user._id)}
                onPaidSwitchChanged={this.onPaidSwitchChanged}
                onPaymentRulesChanged={this.handlePaymentRulesChanged}
                user={this.props.user}
                onOpenStripeSetup={this.onOpenStripeSetup}
              />
            </BorderedBox>
          )}
          <BorderedBox title={"Additional organisers"} videoIcon variant={"h6"} padding="none">
            {!this.props.edit ? (
              <>
                <p>Club managers will be added automatically as additional organisers</p>
                <GameAdditionalOrganisersTable
                  insideHandler={true}
                  organisers={organizers}
                  onChange={this._onAdditionalOrganisersChage}
                />
              </>
            ) : (
              <p>you can edit organisers through organisers column in the games list Table</p>
            )}
          </BorderedBox>
          {this.renderActionButton()}
          {/* Starting Tee Dialog */}
          <Dialog open={this.state.dialog} onBackdropClick={this._closeDialog}>
            <BestHoles
              holesCount={holesCount}
              selectedHoles={game.startingTees || []}
              onHoleClicked={(hole: number) => {
                this._handleHoleClick(hole, holesCount);
              }}
              onSubmit={this._closeDialog}
            />
          </Dialog>
        </>
      );
    else
      return (
        <div className={classes.actionButtonContainer}>
          <Button
            fullWidth
            className={classes.actionButton}
            variant={"contained"}
            color={"secondary"}
            onClick={auxiliary ? hideAuxiliaryDialog : hideDialog}
          >
            Cancel
          </Button>
        </div>
      );
  }

  renderClubSearch(club: any) {
    if (this.props.club) return null;
    return (
      <BorderedBox title={"Club"} variant={"h6"} padding={"none"}>
        <SearchClub dialog onClubSelected={this._handleClubSelection} defaultSelectedItem={club} />
      </BorderedBox>
    );
  }
  renderCourseSearch(course: any) {
    if (this.state.game.course.club?._id && !this.props.course)
      return (
        <BorderedBox title={"Course"} variant={"h6"} padding={"none"}>
          <SearchCourse
            clubId={this.state.game.course.club._id}
            onClubSelected={this._handleCourseSelection}
            defaultSelectedItem={course}
          />
        </BorderedBox>
      );

    return null;
  }
  render() {
    const { classes, copy, onlyGameRule, onlyPresentationConfig } = this.props;
    const { course } = this.state.game;

    if (onlyGameRule) {
      return (
        <div style={{ padding: 10 }}>
          <BorderedBox title={"Game rules"} variant={"h6"}>
            {this.renderGameRulesSelector()}
          </BorderedBox>
          {this.renderActionButton()}
        </div>
      );
    }

    if (onlyPresentationConfig) {
      return (
        <div style={{ padding: 10 }}>
          <BorderedBox title={"Leaderboard"} variant={"h6"}>
            <LeaderboardConfig
              gameId={this.state.game._id}
              leaderboardConfig={this.state.game.leaderboard}
              onLeaderboardConfigChanged={this.handleLeadeboardConfigChanged}
            />
          </BorderedBox>

          <BorderedBox title={"Start Sheet"} variant={"h6"}>
            <PresentationInputs
              fields={this.state.game.startSheet}
              handleInputChange={this.handleStartSheetConfigChange}
              onSwitchChange={this.handleStartSheetConfigChange}
            />
          </BorderedBox>
          {this.renderActionButton()}
        </div>
      );
    }

    return (
      <Paper className={classes.paper}>
        {copy ? (
          this.renderCopyFormFields()
        ) : (
          <>
            {this.props.club && this.props.course ? (
              <BorderedBox title={"Club/Course"} padding={"none"}>
                <p className={"text-center"}>
                  {this.props.club.name}/{this.props.course.name}
                </p>
              </BorderedBox>
            ) : null}
            {this.renderClubSearch(course.club)}
            {this.renderCourseSearch(course)}
            {this.renderFormContent()}
          </>
        )}
      </Paper>
    );
  }
}

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      display: "block",
      position: "relative",
      left: "50%",
      transform: "translateX(-50%)",
      width: "auto",
      maxWidth: 500,
      minWidth: 360,
      backgroundColor: "rgba(255,255,552,0.85)",
      padding: theme.spacing(2),

      [theme.breakpoints.down("sm")]: {
        minWidth: "100%",
      },
    },
    title: {
      fontWeight: "bold",
      textAlign: "center",
    },
    inline: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
    },
    datePicker: {
      width: "100%",
      alignSelf: "center",
    },
    timePicker: {
      width: window.innerWidth < 360 ? "100%" : "50%",
    },
    borderBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    actionButton: {
      marginTop: theme.spacing(1),
    },
    loadingContainer: {
      width: "100%",
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(2),
    },
    actionButtonContainer: {
      display: "flex",
    },
    selectedTournament: {
      margin: 2,
    },
    teesBtn: {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",

      "&:hover": {
        backgroundColor: theme.palette.primary.light,
      },
    },
    holesList: {
      textAlign: "left",
      padding: 5,
      display: "flex",
      flexWrap: "wrap",
      width: "100%",
    },
    hole: {
      marginRight: 2,
      marginTop: 2,
      width: 37,
      height: 37,
      borderRadius: "50%",

      [theme.breakpoints.down("xs")]: {
        width: 50,
        height: 50,
      },
    },
    gameTypeToggleGroup: {
      display: "flex",
      width: "100%",
    },
    gameTypeToggle: {
      flex: 1,
      textTransform: "none",
      fontSize: "0.875rem",
      fontWeight: 500,
      letterSpacing: "0.02em",
      borderColor: theme.palette.divider,
      color: theme.palette.text.primary,
      "&.Mui-selected": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
        },
      },
      "&.Mui-disabled": {
        opacity: 0.45,
      },
    },
    gameTypeCaption: {
      marginTop: theme.spacing(1),
      lineHeight: 1.45,
      "& a": {
        color: theme.palette.primary.main,
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline",
        },
      },
    },
  });

const mapStateToProps = (state: GlobalState) => {
  const { user } = state.auth;
  const { loading } = state.general;
  const { competitions } = state.competitions;
  const { scoreCards } = state.scoreCards;
  const { tournaments } = state.tournaments;
  return {
    user,
    loading,
    competitions: competitions ? Object.values(competitions) : [],
    competitionsObj: competitions,
    scoreCards: scoreCards ? Object.values(scoreCards) : [],
    tournaments: tournaments ? Object.values(tournaments) : [],
    tournamentsObj: tournaments,
  };
};

export default connect(mapStateToProps, {
  insertGame: GameActions.insert,
  joinGame: GameActions.joinGame,
  updateGame: GameActions.update,
  updateGameRule: GameActions.updateGameRule,
  switchComponent: switchComponent,
  getScoreCards: CourseActions.getScoreCards,
  fetchCompetitionsList: CompetitionActions.fetch,
  fetchTournamentsList: TournamentActions.fetch,
  onboardAccount: PaymentAction.onBoardingAccount,
})(withStyles(styles)(GameSetup));
